<template lang="html">

<div class="pgContent">
  <el-form :model="params" :show-message="false" :rules="rules" ref="ruleForm">
      <el-row>
          <el-col class="inpItem" :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
               <div class="iName">
                   <span class="dot" >*</span>
                   <span>建筑物名称</span>
               </div>
               <div class="iContent">
                   <el-form-item prop="buildingName">
                      <el-input v-model="params.buildingName" size="medium" placeholder="请输入楼宇名称"></el-input>
                   </el-form-item>
               </div>
          </el-col>

          <el-col class="inpItem" :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
               <div class="iName">
                   <span class="dot" >*</span>
                   <span>物业单位</span>
               </div>
               <div class="iContent">
                   <el-form-item prop="tenement">
                      <el-input v-model="params.tenement" size="medium" placeholder="请输入物业单位"></el-input>
                   </el-form-item>
               </div>
          </el-col>

          <el-col class="inpItem" :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
               <div class="iName">
                   <span class="dot" >*</span>
                   <span>产权单位</span>
               </div>
               <div class="iContent">
                   <el-form-item prop="propertyUnit">
                      <el-input v-model="params.propertyUnit" size="medium" placeholder="请输入产权单位"></el-input>
                   </el-form-item>
               </div>
          </el-col>

          <el-col class="inpItem" :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
               <div class="iName locSet">
                   <span class="dot" >*</span>
                   <span>地址</span>
               </div>
               <div class="iContent">
                   <el-row>
                        <el-form-item prop="address">
                            <ads-select @selected="mapChange" :adsList="adsStore"  selectType="1" />
                       </el-form-item>
                       <!-- <el-col class="inTerm" :span="11">
                           <span>经度：</span>
                           <div class="inContent">
                               <el-input v-model="params.longitude" disabled size="medium" placeholder=""></el-input>
                           </div>
                       </el-col>
                       <el-col class="inTerm" :offset="2" :span="11">
                           <span>纬度：</span>
                           <div class="inContent">
                               <el-input v-model="params.latitude" disabled size="medium" placeholder=""></el-input>
                           </div>
                       </el-col> -->
                   </el-row>
               </div>
          </el-col>

          <el-col class="inpItem" :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
               <div class="iName">
                   <span class="dot" >*</span>
                   <span>所属街乡</span>
               </div>
               <div class="iContent">
                   <el-form-item prop="jiexiangId">
                       <tree-select code="szjx"
                          :selectId="params.jiexiangId"
                          :moreSelect="false"
                          paramsKey="jiexiang"
                          @selectChange="selectChange"
                          plaText="所在街乡" />
                   </el-form-item>

               </div>
          </el-col>
        <el-col class="inpItem" :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
               <div class="iName">
                   <span class="dot" >*</span>
                   <span>所属功能区</span>
               </div>
               <div class="iContent">
                   <el-form-item prop="parkId">
                     <el-form-item prop="parkId">
                       <dic-select code="ssgnyq"
                          :selectId="params.parkId"
                          paramsKey="park"
                          plaText="请输入所属功能区"
                          @selectChange="selectChange" />
                     </el-form-item>
                   </el-form-item>
               </div>
          </el-col>
          
        <el-col class="inpItem" :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
               <div class="iName">
                   <span class="dot" >*</span>
                   <span>项目类型</span>
               </div>
               <div class="iContent">
                      <el-form-item prop="projectTypeId">
                          <dic-select code="xmlx"
                             :selectId="params.projectTypeId"
                             paramsKey="projectType"
                             plaText="请选择项目类型"
                             @selectChange="selectChange" />
                      </el-form-item>
               </div>
          </el-col>
          

          <el-col class="inpItem" :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
               <div class="iName">
                   <span class="dot" >*</span>
                   <span>是否国有</span>
               </div>
               <div class="iContent">
                    <el-form-item prop="nationalizedId">
                      <dic-select code="isguoyou"
                         :selectId="params.nationalizedId"
                         paramsKey="nationalized"
                         plaText="请选择国有类型"
                         @selectChange="selectChange" />
                    </el-form-item>
               </div>
          </el-col>

        <el-col class="inpItem" :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
               <div class="iName">
                   <span class="dot" >*</span>
                   <span>产业定位</span>
               </div>
               <div class="iContent">
                    <el-form-item prop="locationId">
                      <all-select code="dw"
                         :selectId="params.locationId"
                         paramsKey="location"
                         plaText="请选择产业定位"
                         @selectChange="selectChange" />
                    </el-form-item>
               </div>
          </el-col>


          <el-col class="inpItem" :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
               <div class="iName">
                   <span class="dot" >*</span>
                   <span>是否愿意在市级平台对外发布推介</span>
               </div>
               <div class="iContent">
                      <el-form-item prop="isWillingCityPlatformReleaseRecommendId">
                          <dic-select code="isWillingCityPlatformReleaseRecommend"
                             :selectId="params.isWillingCityPlatformReleaseRecommendId"
                             paramsKey="isWillingCityPlatformReleaseRecommend"
                             plaText="请选择"
                             @selectChange="selectChange" />
                      </el-form-item>
               </div>
          </el-col>
          

          <el-col class="inpItem" :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
               <div class="iName">
                   <span class="dot" >*</span>
                   <span>是否愿意在区级招商工作中对外发布推介</span>
               </div>
               <div class="iContent">
                    <el-form-item prop="isWillingDistrictInvestmentWorkeleaseRecommendId">
                      <dic-select code="isWillingDistrictInvestmentWorkeleaseRecommend"
                         :selectId="params.isWillingDistrictInvestmentWorkeleaseRecommendId"
                         paramsKey="isWillingDistrictInvestmentWorkeleaseRecommend"
                         plaText="请选择"
                         @selectChange="selectChange" />
                    </el-form-item>
               </div>
          </el-col>

        <el-col class="inpItem" :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
               <div class="iName">
                   <span class="dot" >*</span>
                   <span>不希望对外发布的原因</span>
               </div>
               <div class="iContent">

                   <el-form-item prop="notPublishReason">
                       <el-input v-model="params.notPublishReason" size="medium" placeholder="请输入不希望对外发布的原因"></el-input>
                   </el-form-item>
               </div>
          </el-col>
          
        <el-col class="inpItem" :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
               <div class="iName">
                   <span class="dot" >*</span>
                   <span>是否愿意承接国际组织办公场所</span>
               </div>
               <div class="iContent">
                    <el-form-item prop="isWillingUndertakeInterOrganizationWorkspaceId">
                      <dic-select code="isWillingUndertakeInterOrganizationWorkspace"
                         :selectId="params.isWillingUndertakeInterOrganizationWorkspaceId"
                         paramsKey="isWillingUndertakeInterOrganizationWorkspace"
                         plaText="请选择"
                         @selectChange="selectChange" />
                    </el-form-item>
               </div>
          </el-col>

          <el-col class="inpItem" :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
               <div class="iName">
                   <span class="dot" >*</span>
                   <span>规划建筑面积(平方米)</span>
               </div>
               <div class="iContent">
                   <el-form-item prop="planBuildingArea">
                       <el-input-number v-model="params.planBuildingArea" size="medium" />
                   </el-form-item>
               </div>
          </el-col>
        <el-col class="inpItem" :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
               <div class="iName">
                   <span class="dot" >*</span>
                   <span>当前空置可招商面积（平方米）</span>
               </div>
               <div class="iContent">
                   <el-form-item prop="totalVacantArea">
                       <el-input-number v-model="params.totalVacantArea" size="medium" />
                   </el-form-item>
               </div>
          </el-col>


          <el-col class="inpItem" :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
               <div class="iName">
                   <span class="dot" >*</span>
                   <span>招商负责人</span>
               </div>
               <div class="iContent">

                   <el-form-item prop="leadingCadre">
                       <el-input v-model="params.leadingCadre" size="medium" placeholder="请输入招商负责人"></el-input>
                   </el-form-item>
               </div>
          </el-col>

          <el-col class="inpItem" :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
               <div class="iName">
                   <span class="dot" >*</span>
                   <span>负责人手机号</span>
               </div>
               <div class="iContent">
                   <el-form-item prop="leadingCadrePhone">
                       <el-input v-model="params.leadingCadrePhone" size="medium" placeholder="请输入负责人手机号"></el-input>
                   </el-form-item>
               </div>
          </el-col>
        <el-col class="inpItem" :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
               <div class="iName">
                   <span class="dot" >*</span>
                   <span>负责人邮箱</span>
               </div>
               <div class="iContent">
                   <el-form-item prop="leadingCadreEmail">
                       <el-input v-model="params.leadingCadreEmail" size="medium" placeholder="请输入负责人邮箱"></el-input>
                   </el-form-item>
               </div>
          </el-col>
      </el-row>

      <el-row>
          <el-col class="textItem" :xs="24" :sm="24" :md="24" :lg="12" :xl="8">
               <div class="iName">
                   <span>周边交通情况</span>
               </div>
               <div class="iContent">
                   <el-form-item prop="trafficCondition">
                       <el-input v-model="params.trafficCondition" :rows="3" type="textarea" size="medium" placeholder="例：距离XX公交站500米，XX地铁站700米，四环路1公里，XX高速2.5公里" />
                   </el-form-item>
               </div>
          </el-col>

          <el-col class="textItem" :xs="24" :sm="24" :md="24" :lg="12" :xl="8">
               <div class="iName">
                   <span>周边公共配套情况</span>
               </div>
               <div class="iContent">
                   <el-form-item prop="supportingSituation">
                       <el-input v-model="params.supportingSituation" :rows="3" type="textarea" size="medium" placeholder="请输入商业、餐饮、绿化等配套设施" />
                   </el-form-item>
               </div>
          </el-col>

          <el-col class="textItem" :xs="24" :sm="24" :md="24" :lg="12" :xl="8">
               <div class="iName">
                   <span>其他补充说明</span>
               </div>
               <div class="iContent">
                   <el-form-item prop="other">
                       <el-input v-model="params.other" :rows="3" type="textarea" size="medium" placeholder="请输入免部分租期，车位情况，特色服务" />
                   </el-form-item>
               </div>
          </el-col>

      </el-row>
    <div class="imgUpload">
      <div class="tips">
           <span class="dot" >*</span>
          上传楼宇图片（分为楼外观，大厅，室内环境，局部平面图几类上传）
          <span>只能上传jpg/jpeg/png/gif文件，且不超过 2M (115*70推荐)</span>
      </div>
      <el-form-item prop="image">
      <imgsUp :files="params.image" @fileChange="imgChange"></imgsUp>
      </el-form-item>
    </div>

  </el-form>

  

</div>

</template>

<script>
import imgsUp from "./imgsUpload";
var isPhone = (rule, value, callback) => {
    if (!value) {
        return callback(new Error('联系电话不能为空'));
    }else{
        let pattern = /^1[3|4|5|7|8][0-9]{9}$/;
        if(pattern.test(value)){
            callback();
        }else{
            return callback(new Error('联系电话格式不正确'));
        }
    }
}
var numCheck = (rule, value, callback) => {
    if(value <= 0){
       return callback(new Error());
    }else{
       callback();
    }
}
import { mapGetters } from 'vuex';
export default {
   props:['resData'],
   components:{
      imgsUp
   },
   computed:{
      ...mapGetters(['userInfo'])
   },
   data(){
      return{

          params:{
              id:'',         //主键id
              buildingName:'',         //楼宇名称
              tenement:'',         //物业单位
              propertyUnit:'',         //产权单位

              longitude:'',         //楼宇坐标经度
              latitude:'',         //楼宇坐标纬度
              address:'',         //地址

              jiexiang:'',         //所在街乡（数据字典）
              jiexiangId:'',         //所在街乡id

              location:'',         //定位（数据字典）
              locationId:'',         //定位id

              park:'',         //所属功能/园区（数据字典）
              parkId:'',         //所属功能/园区id
              totalVacantArea:'',         //空置总面积（平方米）

              projectType:'',         //项目类型（数据字典）
              projectTypeId:'',         //项目类型id

              leadingCadre:'',         //招商负责人
              leadingCadrePhone:'',         //负责人手机号

              trafficCondition:'',         //周边交通情况
              supportingSituation:'',         //周边公共配套情况
              other:'',         //其他补充说明

              uploadUser:'',
              uploadUserId:'',

              image:'',         //图片地址

              status:0,         //状态0初始化1已上传/待审核2发布3审核失败4未上传
              nationalizedId:'',//是否国有
              nationalized:'',//是否国有
                isWillingCityPlatformReleaseRecommend:'',//是否愿意在市级平台对外发布推介
                isWillingCityPlatformReleaseRecommendId:'',//否愿意在市级平台对外发布推介id
                isWillingDistrictInvestmentWorkeleaseRecommend:'',//是否愿意在区级招商工作中对外发布推介
                isWillingDistrictInvestmentWorkeleaseRecommendId:'',//是否愿意在区级招商工作中对外发布推介Id
                notPublishReason:'',//不希望对外发布的原因
                isWillingUndertakeInterOrganizationWorkspace:'',//是否愿意承接国际组织办公场所
                isWillingUndertakeInterOrganizationWorkspaceId:'',//是否愿意承接国际组织办公场所Id
                planBuildingArea:0,//规划建筑面积(平方米)
                leadingCadreEmail:'',//负责人邮箱
                uploadOrg:'',
              uploadOrgId:'',
          },
          
          adsStore:[],

          rules:{
              buildingName:[{required: true, trigger: 'blur'}],
              tenement:[{required: true, trigger: 'blur'}],
              propertyUnit:[{required: true, trigger: 'blur'}],
              jiexiangId:[{required: true, trigger: 'blur'}],
              locationId:[{required: true, trigger: 'blur'}],
              parkId:[{required: true, trigger: 'blur'}],
              totalVacantArea:[{validator: numCheck, trigger: 'blur'}],
              projectTypeId:[{required: true, trigger: 'blur'}],
              leadingCadre:[{required: true, trigger: 'blur'}],
              leadingCadrePhone:[{validator: isPhone, trigger: 'blur'}],
              nationalizedId:[{required: true, trigger: 'blur'}],
              address:[{required: true, trigger: 'blur'}],
              image:[{required: true, trigger: 'blur'}],

              isWillingCityPlatformReleaseRecommendId:[{required: true, trigger: 'blur'}],
              isWillingDistrictInvestmentWorkeleaseRecommendId:[{required: true, trigger: 'blur'}],
              notPublishReason:[{required: true, trigger: 'blur'}],
              isWillingUndertakeInterOrganizationWorkspaceId:[{required: true, trigger: 'blur'}],
              planBuildingArea:[{validator: numCheck, trigger: 'blur'}],
              leadingCadreEmail:[{required: true, trigger: 'blur'}],
              
          }

      }
   },
   watch:{
     resData(e){
        //    console.log(this.userInfo);
         if(e){
             this.params = e.industrialSpace;
             if(this.params.address){
                 this.adsStore = [{
                       name:this.params.address.split(',')[0],
                       id:this.params.address.split(',')[1],
                       address:this.params.address.split(',')[2],
                       latLng:{
                       lng:this.params.longitude,
                       lat:this.params.latitude
                     }
                 }];
             }
         }
     }
   },
   methods:{
     selectChange(e){
         
         this.params[e.paramsKey] = e.name;
         this.params[e.paramsKey + 'Id'] = e.id;
         console.log(this.params);
     },
     tabSelect(e){
         let arr = e.paramsKey.split(',');
         this.subData[arr[1]][arr[0]] = e.name;
         this.subData[arr[1]][arr[0] + 'Id'] = e.id;
     },
     goSave(){
       if(!this.params.image||(this.params.image&&this.params.image=='[]')){
          this.$message.error('图片必须上传！');
          return;
       }
       if(!this.params.address){
          this.$message.error('地址必须选择！');
          return;
       }
    //    console.log(this.userInfo);
       return new Promise((resolve,reject) => {
           this.$refs.ruleForm.validate((valid) => {
             
               this.params.uploadUser = this.userInfo.userName;
               this.params.uploadUserId = this.userInfo.userId;
               this.params.uploadOrg = this.userInfo.org;
               this.params.uploadOrgId = this.userInfo.orgId;
               resolve({
                   canSave:valid,
                   data:this.params
               })
           })
       })
     },
     imgChange:function(e){
         this.params.image = JSON.stringify(e);
     },
     mapChange:function(e){    //  位置地点
         this.params.address = e.name + ',' + e.id;
         if(e.address){
             this.params.address = this.params.address  + ',' + e.address;
         };
         this.params.latitude = e.latLng.lat;
         this.params.longitude = e.latLng.lng;
     },
   }

}
</script>

<style lang="scss" scoped>

.pgContent{
    margin: 30px 35px;
    position: relative;
    .el-select{
        display: block;
        width: 100%;
    }
    .el-cascader{
        display: block;
    }
    .inpItem,.textItem{
        padding:0px 10px;
        height: 90px;
        .iName{
            font-size: 14px;
            margin-bottom: 6px;

            .dot{
                color:red;
            }
        }

        .locSet{
            cursor: pointer;
            i{
                color: #409EFF;
                font-size: 16px;
            }
        }

        .inTerm{
            position: relative;
            font-size: 14px;
            span{
                float: left;
                line-height: 36px;
            }
            .inContent{
                margin-left: 50px;
            }
        }
    }

    .textItem{
        height: 150px;
    }

    .imgUpload{
        // margin-top: 60px;
        padding: 0 10px;
        .tips{
           font-size: 14px;
           margin-bottom: 10px;
           span{
              color: #999999;
           }
           .dot{
             color:red;
           }
        }
    }

}

</style>



// WEBPACK FOOTER //
// buildingSave.vue?33f371d8